import { tagmanager as TagManager } from '@ahmdigital/analytics';

import { EVENTS } from '../google/constants';
import { setAnalyticsClientId } from '../../../../utils/get-analytics-client-id';
import { setCookieForMembers } from '../../utils/cookie-for-members';
import browser from '../../utils/browser';
import config from '../../config';
import getMemberNumber from '../../utils/get-oms-member-number';

const ga4TrackingId = config.get('google:analytics:ga4TrackingId');
export default class GA4Analytics {
  static initialise() {
    browser.getWindow().gtag('config', ga4TrackingId);
    setAnalyticsClientId();
    GA4Analytics.userId(getMemberNumber());
  }

  static userId(id: string | undefined) {
    if (id) {
      setCookieForMembers('health', { id });

      // GA4
      browser.getWindow().gtag('set', {
        // eslint-disable-next-line camelcase
        send_to: ga4TrackingId,
        // eslint-disable-next-line camelcase
        user_id: id,
      });
    }
  }

  static submit({ data = {}, name }: { data?: Record<string, unknown>; name: string }) {
    TagManager.submit(
      name,
      // we're using SST for the purchase event so we need to remove the send_to to avoid duplication of events in GTM
      name === EVENTS.ECOMMERCE_GA4.PURCHASE
        ? data
        : {
            ...data,
            // eslint-disable-next-line camelcase
            send_to: ga4TrackingId,
          },
    );
  }
}
